import { parseCookies } from '@cian/utils';
import {
  FILTERS_SEARCH_SEARCH_REQUEST_START_REQUESTED,
  FILTERS_SEARCH_SEARCH_REQUEST_FETCHING,
  FILTERS_SEARCH_SEARCH_REQUEST_FINISHED,
} from 'shared/actions/search';
import { IAppState, TActions } from 'shared/common/state';
import { ISerpDataQueristringToUri, IKpOffers } from 'shared/offer';
import { INewbuildingSimilarOffersBlockSchema } from 'shared/repositories/search-offers.legacy/v2/types/NewbuildingSimilarOffersBlockSchema';
import { defaultHideOfferState } from 'shared/serp/state/hide_offer';
import { triggerHeaderCategoryChanged, triggerHeaderRegionChanged } from 'shared/utils/events';
import { getNewbuildingBannerRandomBoolean } from 'shared/utils/getNewbuildingBannerRandomBoolean';

export function searchReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case FILTERS_SEARCH_SEARCH_REQUEST_START_REQUESTED:
    case FILTERS_SEARCH_SEARCH_REQUEST_FETCHING:
      return {
        ...state,
        isFetching: true,
      };

    case FILTERS_SEARCH_SEARCH_REQUEST_FINISHED:
      triggerHeaderCategoryChanged(action.data.jsonQuery);
      triggerHeaderRegionChanged(state.currentLocation);

      return {
        ...state,
        results: {
          ...state.results,
          avgPriceInformer: action.data.avgPriceInformer || null,
          queryString: action.data.queryString,
          quickLinks: action.quickLinks,
          jsonQuery: action.data.jsonQuery,
          aggregatedOffers: action.data.aggregatedCount,
          extendedOffersCount: action.data.extendedOffersCount,
          developerInfo: action.developerInfo,
          developerInfoRedesigned: action.developerInfoRedesigned,
          fastLinks: action.data.topHitsLinks || null,
          fullUrl: action.data.fullUrl,
          newbuildingInfo: action.newbuildingInfo,
          offers: action.data.offersSerialized,
          seo: action.data.seoData,
          seoLinks: action.data.seoLinks,
          totalOffers: action.data.offerCount,
          suggestions: action.data.suggestOffersSerializedList || null,
          suggestionsQuery: action.data.suggestionsQuery,
          qsToUris: (action.data.qsToUris as ISerpDataQueristringToUri) || null,
          villageInfo: action.villageInfo,
          kp: action.data.kp as IKpOffers,
          extensionTypes: action.data.extensionTypes || [],
          puids: action.data.puids,
          ymEvents: action.data.ymEvents,
        },
        similarNewobjects: action.similarNewobjects,
        breadcrumbs: action.commercialBreadcrumbs?.breadcrumbs ?? action.data.breadcrumbs,
        isFetching: false,
        hideOffer: defaultHideOfferState,
        mlRankingGuid: action.data.mlRankingGuid || null,
        mlRankingModelVersion: action.data.mlRankingModelVersion || null,
        newbuildingIdsForBuildersPromoSlider: action.data.newbuildingIdsForBuildersPromoSlider,
        newbuildingPromoBuilderOffers: action.data.specialPromoBuilderOffers || null,
        specialPromoSecondaryOffers: action.data.specialPromoSecondaryOffers || null,
        isNewbuildingsOnly: (action.data.jsonQuery.building_status || { value: undefined }).value === 2,
        collections: action.data.collections,
        newbuildingSimilarOffersBlock: action.data
          .newbuildingSimilarOffersBlock as INewbuildingSimilarOffersBlockSchema,
        isNewbuildingBannerRandomRotationEnabled: getNewbuildingBannerRandomBoolean(
          state.config,
          parseCookies(document.cookie),
        ),
        newbuildingInformation: action.data.newbuilding || null,
        recommendedVillages: action.recommendedVillages,
        suburbanBuildersProjects: action.suburbanBuildersProjects,
        newbuildingLayouts: action.newbuildingLayouts || null,
        newbuildingFlatSaleQueryString: action.data.newbuildingFlatSaleQueryString,
      };
    default:
      return state;
  }
}
